module.exports = __webpack_public_path__ + "static/media/dh.50ba9b42.jpg";